import styled, { css } from 'styled-components';
import { ellipsisText, FlexCenterAligned } from '../../../styled/common';
import { Typography } from '../Typography';
import { Breakpoints } from '../../../styled/constants';

export const ToggleContainer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.background.secondary};
  padding: 5px;
  border-radius: 30px;
  height: 50px;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  cursor: default;

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    max-width: 335px;
  }

  @media (max-width: 370px) {
    flex: 1;
    min-width: 0;
  }
`;

export const ToggleTrack = styled.div`
  position: relative;
  display: flex;
  gap: 5px;
  border-radius: 30px;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const Highlight = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 30px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  transition:
    -webkit-clip-path 0.3s ease,
    clip-path 0.3s ease;
  z-index: 0;
  pointer-events: none;
`;

export const OptionText = styled(Typography)<{ $isSelected: boolean }>`
  color: ${({ theme }) => theme.colors.text.primary};
  transition: color 0.3s ease;
  z-index: 1;
  position: relative;
  text-align: center;
  ${ellipsisText};
`;

export const ToggleOption = styled(FlexCenterAligned)<{
  $isSelected: boolean;
  $allowReselect: boolean;
}>`
  border-radius: 30px;
  position: relative;
  z-index: 1;
  padding: 0 10px;
  text-wrap-mode: nowrap;
  cursor: ${({ $allowReselect, $isSelected }) =>
    !$allowReselect && $isSelected ? 'default' : 'pointer'};

  ${({ $isSelected }) =>
    !$isSelected &&
    css`
      @media (hover: hover) {
        &:hover {
          ${OptionText} {
            color: ${({ theme }) => theme.colors.systemColors.blue};
          }
        }
      }
    `};

  @media (max-width: 370px) {
    padding: 0 7px;
    flex: 1;
    min-width: 0;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 15px;
  }
`;
